module.exports = __webpack_public_path__ + "img/logo_blanco.e03350fd.png";